import ClientAssignments from './ClientAssignments';

export default ClientAssignments;
